export default __webpack_public_path__ + "static/about-us-security1--mobile-b96f0c316b8ad9e5e05643cf79fa9e01.webp";